import { render } from "./GuildSelector.vue?vue&type=template&id=44dd42a0"
import script from "./GuildSelector.vue?vue&type=script&lang=js"
export * from "./GuildSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__